import { Injectable } from '@angular/core';
import { CrudService } from 'app/shared/crud-service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Resolve
} from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { EmpresaDTO } from './empresa.model';

@Injectable({
  providedIn: 'root'
})
export class EmpresasService extends CrudService<EmpresaDTO> implements Resolve<any> {
  constructor(protected http: HttpClient) {
      super(http, `${environment.apiUrl}/v1/Empresa`);
  }

  resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
      return new Promise<void>((resolve, reject) => {
          Promise.all([this.getAll()]).then(() => {
              resolve();
          }, reject);
      });
  }
}
